import dayjs from 'dayjs'

import { scopedTranslation } from '@utils/I18n'
import type { Blast, BlastAudience, BlastStatus } from '../../types'

const t = scopedTranslation('comms_management.blasts_index')

export const formatDate = (iso: string) => dayjs(iso).format('D MMM YYYY')
export const formatDateTime = (iso: string) => dayjs(iso).format('D MMM YYYY, h:mm a')

export function audienceLabel(audience: BlastAudience): string {
  if (audience.kind !== 'all_rsvps') return t('audience.all_members')
  if (audience.rsvpType === 'attendees') return t('audience.attendees')
  if (audience.rsvpType === 'non_attendees') return t('audience.non_attendees')
  return t('audience.rsvps')
}

export function statusDetail(blast: Blast): string | undefined {
  if (blast.status === 'sent' && blast.sentAt) return formatDate(blast.sentAt)
  if (blast.status === 'scheduled' && blast.scheduledFor) return formatDateTime(blast.scheduledFor)
  return undefined
}

export const unavailableReason = (status: BlastStatus): string | null => {
  const key = { sent: 'sent', approved: 'approved', scheduled: 'scheduled', 'awaiting approval': 'awaiting' }[
    status as string
  ]
  return key ? t(`unavailable.${key}`) : null
}
